import { api } from '@/lib/api';
import type { ReportRange, TxRange, VendorDashboardStats, VendorReports, VendorTransactions } from './types';

export async function fetch_dashboard_stats(): Promise<VendorDashboardStats> {
  const res = await api.get<VendorDashboardStats>('/vendor/stats/dashboard');
  return res.data;
}

export async function fetch_reports(range: ReportRange): Promise<VendorReports> {
  const res = await api.get<VendorReports>('/vendor/stats/reports', { params: { range } });
  return res.data;
}

export async function fetch_transactions(range: TxRange): Promise<VendorTransactions> {
  const res = await api.get<VendorTransactions>('/vendor/stats/transactions', { params: { range } });
  return res.data;
}
